<template>
  <div class="upload-section upload-section--default">
    <!-- Desktop Upload Modal -->
    <PLPUploadModal
      :isOpen="showUploadModal"
      :joineryHost="joineryHost"
      @close="showUploadModal = false"
      @upload-complete="handleModalUploadComplete($event)"
      @upload-error="handleUploadError($event)"
      @upload-initiated="handleUploadInitiated($event)"
      @upload-progress="handleUploadProgress($event)"
    />

    <teleport to="#teleportUpload">
      <UploadedImage
        v-if="uploadedArtwork && uploadedArtwork.artwork"
        :uploadedArtwork="uploadedArtwork"
        @removeArtwork="handleRemoveArtwork($event)"
      />
      <!-- Desktop: Open modal for change, Mobile: Direct upload -->
      <div v-if="uploadedArtwork && uploadedArtwork.artwork" class="upload-remove hide-mobile" @click="openUploadModal">
        Change Photo
      </div>
      <div
        v-if="uploadedArtwork && uploadedArtwork.artwork"
        class="upload-remove hide-desktop"
        @click="handleChangeImageMobile"
      >
        Change Photo
      </div>
      <!-- Desktop: Open modal, Mobile: Direct upload -->
      <button v-else class="upload-button upload-button--desktop hide-mobile" @click="openUploadModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <path
            d="M16 19H2V5H11V3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H16C17.1 21 18 20.1 18 19V10H16V19ZM8.21 15.83L6.25 13.47L3.5 17H14.5L10.96 12.29L8.21 15.83ZM18 3V0H16V3H13C13.01 3.01 13 5 13 5H16V7.99C16.01 8 18 7.99 18 7.99V5H21V3H18Z"
            fill="black"
          />
        </svg>
        {{ buttonText }}
      </button>
      <ArtworkUploadButton
        v-if="!(uploadedArtwork && uploadedArtwork.artwork)"
        ref="ArtworkUploadButtonPinned"
        :title="buttonText"
        class="upload-button hide-desktop"
        :joineryHost="joineryHost"
        @upload-complete="handleUploadComplete($event)"
        @upload-error="handleUploadError($event)"
        @upload-initiated="handleUploadInitiated($event)"
      >
        Upload
      </ArtworkUploadButton>
      <div class="hide-mobile">
        <div :class="errorClass">
          <span class="icon icon--upload-error" aria-label="Upload Error"></span>
          {{ errorMessage }}
        </div>
      </div>
    </teleport>
    <teleport to="#pinnedUpload">
      <UploadedImage
        v-if="uploadedArtwork && uploadedArtwork.artwork"
        :uploadedArtwork="uploadedArtwork"
        @removeArtwork="handleRemoveArtwork($event)"
      />
      <!-- Desktop: Open modal for change, Mobile: Direct upload -->
      <div class="upload-remove hide-mobile" v-if="uploadedArtwork && uploadedArtwork.artwork" @click="openUploadModal">
        Change Photo
      </div>
      <div
        class="upload-remove hide-desktop"
        v-if="uploadedArtwork && uploadedArtwork.artwork"
        @click="handleChangeImageMobile"
      >
        Change Photo
      </div>
      <!-- Desktop: Open modal, Mobile: Direct upload -->
      <button v-else class="upload-button upload-button--desktop hide-mobile" @click="openUploadModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
          <path
            d="M16 19H2V5H11V3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H16C17.1 21 18 20.1 18 19V10H16V19ZM8.21 15.83L6.25 13.47L3.5 17H14.5L10.96 12.29L8.21 15.83ZM18 3V0H16V3H13C13.01 3.01 13 5 13 5H16V7.99C16.01 8 18 7.99 18 7.99V5H21V3H18Z"
            fill="black"
          />
        </svg>
        {{ buttonText }}
      </button>
      <ArtworkUploadButton
        v-if="!(uploadedArtwork && uploadedArtwork.artwork)"
        ref="ArtworkUploadButton"
        :title="buttonText"
        class="upload-button hide-desktop"
        :joineryHost="joineryHost"
        @upload-complete="handleUploadComplete($event)"
        @upload-error="handleUploadError($event)"
        @upload-initiated="handleUploadInitiated($event)"
      >
        Upload
      </ArtworkUploadButton>
      <div class="hide-mobile">
        <div :class="errorClass">
          <span class="icon icon--upload-error" aria-label="Upload Error"></span>
          {{ errorMessage }}
        </div>
      </div>
    </teleport>
    <div ref="artworkContainer" class="upload-section-content-wrapper">
      <div class="upload-section-content" v-if="uploadedArtwork && uploadedArtwork.artwork">
        <UploadedImage :uploadedArtwork="uploadedArtwork" @removeArtwork="handleRemoveArtwork($event)" />
        <!-- Desktop: Open modal for change, Mobile: Direct upload -->
        <div class="upload-remove hide-mobile" @click="openUploadModal">Change Photo</div>
        <div class="upload-remove hide-desktop" @click="handleChangeImageMobile">Change Photo</div>
        <ArtworkUploadButton
          ref="ArtworkUploadButtonHidden"
          :title="buttonText"
          class="upload-button upload-button--hidden"
          :class="{ 'is-processing': isProcessing }"
          :joineryHost="joineryHost"
          @upload-complete="handleUploadComplete($event)"
          @upload-error="handleUploadError($event)"
          @upload-initiated="handleUploadInitiated($event)"
          @upload-progress="handleUploadProgress($event)"
        >
          Upload
        </ArtworkUploadButton>
      </div>
      <!-- Desktop: Open modal, Mobile: Direct upload -->
      <template v-else>
        <button
          class="upload-button upload-button--desktop hide-mobile"
          :class="{ 'is-processing': isProcessing }"
          @click="openUploadModal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path
              d="M16 19H2V5H11V3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H16C17.1 21 18 20.1 18 19V10H16V19ZM8.21 15.83L6.25 13.47L3.5 17H14.5L10.96 12.29L8.21 15.83ZM18 3V0H16V3H13C13.01 3.01 13 5 13 5H16V7.99C16.01 8 18 7.99 18 7.99V5H21V3H18Z"
              fill="black"
            />
          </svg>
          {{ buttonText }}
        </button>
        <ArtworkUploadButton
          ref="ArtworkUploadButton"
          :title="buttonText"
          class="upload-button hide-desktop"
          :class="{ 'is-processing': isProcessing }"
          :joineryHost="joineryHost"
          @upload-complete="handleUploadComplete($event)"
          @upload-error="handleUploadError($event)"
          @upload-initiated="handleUploadInitiated($event)"
          @upload-progress="handleUploadProgress($event)"
        >
          Upload
        </ArtworkUploadButton>
      </template>
      <div class="hide-desktop">
        <div :class="errorClass">
          <span class="icon icon--upload-error" aria-label="Upload Error"></span>
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArtworkUploadButton from '@framebridge/toolbox/ArtworkUploadButton';
import PLPUploadModal from './PLPUploadModal.vue';
import UploadedImage from './UploadedImage.vue';

export default {
  name: 'UploadComponent',
  components: {
    ArtworkUploadButton,
    UploadedImage,
    PLPUploadModal,
  },

  data() {
    return {
      joineryHost: SDG?.Data?.joineryHost || 'https://staging.framebridge.com',
      headingText: '',
      errorMessage: '',
      errorClass: 'hide',
      isPinned: false,
      buttonText: 'Upload Photo',
      uploadedArtwork: {},
      isProcessing: false,
      uploadProgress: 0,
      defaultText: '',
      uploadedText: '',
      showUploadModal: false,
    };
  },
  mounted() {
    this.uploadedArtwork = this.getLocalStorageItem('uploadedArtwork');

    // set the heading text
    this.setHeadingText();
  },
  methods: {
    openUploadModal() {
      this.showUploadModal = true;
    },
    handleModalUploadComplete(data) {
      this.showUploadModal = false;
      this.handleUploadComplete(data);
    },
    initializeObserver() {
      const elementToObserve = this.$refs.artworkContainer;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.isPinned = false;
            } else {
              // Element is not in view and toolbar is pinned
              this.isPinned = true;
            }
          });
        },
        {
          root: null,
          threshold: 0.9,
          rootMargin: '-90px',
        }
      );

      // Start observing the element
      observer.observe(elementToObserve);
    },
    getLocalStorageItem(key) {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    },

    handleUploadComplete(data) {
      localStorage.setItem('uploadedArtwork', JSON.stringify(data));
      this.uploadedArtwork = data;
      this.headingText = this.uploadedText;

      const changeEvent = new CustomEvent('uploadItem', {
        detail: {
          added: true,
          removed: false,
        },
      });

      window.dispatchEvent(changeEvent);
      this.isProcessing = false;
      this.$forceUpdate();
    },
    handleUploadError(data) {
      this.errorMessage = `${data || 'Unknown error'}`;
      this.errorClass = 'upload-error';
      this.isProcessing = false;
    },
    handleUploadInitiated() {
      this.errorClass = 'hide';
      this.buttonText = 'Uploading...';
      this.isProcessing = true;
    },
    handleRemoveArtwork() {
      localStorage.removeItem('uploadedArtwork');
      localStorage.removeItem("currentFrameSpec");
      this.uploadedArtwork = null; // Reset the uploadedArtwork to null
      this.headingText = this.defaultText;

      const changeEvent = new CustomEvent('uploadItem', {
        detail: {
          added: false,
          removed: true,
        },
      });

      window.dispatchEvent(changeEvent);
      this.buttonText = 'Upload Photo';

      this.$forceUpdate();
    },
    handleChangeImageMobile() {
      if (this.$refs.ArtworkUploadButtonHidden) {
        this.$refs.ArtworkUploadButtonHidden.triggerImageUpload();
      }
    },
    handleUploadProgress(data) {
      const { percentComplete } = data;
      const roundedPercentComplete = Math.round(percentComplete);
      this.uploadProgress = { percentComplete: roundedPercentComplete };
      this.headingText = `${roundedPercentComplete}% Uploaded`;
    },
    setHeadingText() {
      // Set default and uploaded text from attributes in mounted lifecycle
      this.defaultText =
        this.$el.parentElement.getAttribute('data-section-heading') ||
        'Framing a digital photo? Upload here to see it in all frames.';
      this.uploadedText =
        this.$el.parentElement.getAttribute('data-section-uploaded-heading') ||
        'Previewing your digital photo in all frames. Select a frame to get started.';

      // set the heading text
      if (this.uploadedArtwork && this.uploadedArtwork.artwork) {
        this.headingText = this.uploadedText;
      } else {
        this.headingText = this.defaultText;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-button {
  &--hidden {
    opacity: 0;
    pointer-events: none;
    position: absolute;
    visibility: hidden;
  }

  &--desktop {
    align-items: center;
    background: #eee171;
    border: none;
    color: #000;
    cursor: pointer;
    display: flex;
    font-family: 'Apercu', sans-serif;
    font-size: 0.875rem;
    font-weight: 700;
    gap: 0.625rem;
    letter-spacing: 0.28px;
    line-height: 1.25rem;
    height: 46px;
    justify-content: center;
    padding: 14px 50px;
    transition: background-color 0.2s, color 0.2s;

    &:hover {
      background: #000;
      color: #fff;

      svg path {
        fill: #fff;
      }
    }

    &.is-processing {
      opacity: 0.7;
      pointer-events: none;
    }
  }
}
</style>
